import { realtimeService } from "../../realtime/RealtimeService";
import { ServerEvents } from "../../realtime/types/events";

// Initialize connection automatically
realtimeService.init();

/**
 * Backward compatibility facade for socket.on / socket.emit calls
 */
export const socket = {
    on: (eventName, handler) => realtimeService.on(eventName, handler),
    off: (eventName, handler) => realtimeService.off(eventName, handler),
    emit: (eventName, ...args) => realtimeService.transport.invoke(eventName, ...args),
    get id() {
        return realtimeService.getConnectionId();
    }
};

export const registerOnilneUser = (user) => {
    realtimeService.registerUser(user);
};

export const getOnilneUser = () => {
    realtimeService.getOnlineUsers();
    return {};
};

export const UserLogout = (user) => {
    realtimeService.userLogout(user);
};

export const UserChangeCurrentPage = (title, pathname, UserId) => {
    setTimeout(() => {
        realtimeService.setPageTitle(UserId, title, pathname);
    }, 1000);
};

export const SendEmailBySocket = (Title, Message, Users) => {
    realtimeService.sendEmail(Title, Message, Users);
};

export const UpdateGameScoreBySocket = (UserId) => {
    realtimeService.updateGameScore(UserId);
};

export const SetSocket = (UserId, socketId) => {
    // Handled automatically via SignalR connection
};

export const ShareFileBySocket = (StudentId, File) => {
    realtimeService.shareFile(StudentId, File);
};

export const ShareLessonBySocket = (StudentId, Lesson, IndexType) => {
    realtimeService.shareLesson(StudentId, Lesson, IndexType);
};

export const ShareMissionBySocket = (StudentId, Mission) => {
    realtimeService.shareMission(StudentId, Mission);
};

export const notificationIsView = (notificationType, UserId) => {
    realtimeService.notificationIsView(notificationType, UserId);
};

export const SendContactBySocket = (Title) => {
    realtimeService.sendContactUs(Title);
};

export const SchoolRegisterBySocket = (Title) => {
    realtimeService.schoolRegister(Title);
};

export const ErrorReportBySocket = () => {
    realtimeService.errorReport();
};

export const ErrorReportIsSolveBySocket = (ErrorRepor) => {
    realtimeService.errorReportIsSolve(ErrorRepor);
};

export { realtimeService, ServerEvents };
export default realtimeService;
